
import { Loader } from "shared/ui/components/Loader";

import { SessionProviderProps } from "./SessionProvider.types";

import styles from "./SessionProvider.module.scss";

const SessionProvider = ({
  loading,
  children,
}: SessionProviderProps) =>
  loading ? (
    <Loader className={styles.loading} color="#67AE6A" />
  ) : (
    children
  );

export default SessionProvider;
